module.exports = __webpack_public_path__ + "static/media/speakers_logos_ZUAE.d423efbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_ZUAE.jpg
// module id = 284
// module chunks = 0